import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c3734cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "itemShort" }
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "itemoverlay" }, null, -1))
const _hoisted_4 = { class: "overlayContent" }
const _hoisted_5 = { class: "overlayCategory" }
const _hoisted_6 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: "/projects/detail",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openDetail(_ctx.item!))),
    exact: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass('projectItem ' + _ctx.item?.classOverride ?? '')
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.item?.thumbnail?.path,
            alt: _ctx.item?.name
          }, null, 8, _hoisted_2)
        ]),
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.item.category), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.item?.name), 1)
        ])
      ], 2)
    ]),
    _: 1
  }))
}